module.exports = __webpack_public_path__ + "img/revenue.117058e7.png";